export default {
  // Dashboard
  greeting: 'Good day, {name}',
  defaultName: 'there',
  memberSince: 'Member since {date} ·',
  accountSettings: 'Account settings',
  verifyEmailTitle: 'Verify your email',
  verifyEmailBody: 'Your email address is not yet verified. Verify it to unlock purchases up to €50.',
  resendVerification: 'Resend verification email',
  emailSent: 'Email sent ✓',
  purchaseAccess: 'Purchase access',
  emailVerifiedCanPurchase: 'Email verified — can purchase items up to €50',
  verifyEmailToPurchase: 'Verify your email to purchase up to €50',
  kycApprovedCanPurchase: 'KYC approved — can purchase items over €50',
  kycRequired: 'KYC required for purchases over €50',
  accessEmailLabel: 'Email verified',
  accessEmailHint: 'Can purchase items up to €50',
  accessKycLabel: 'KYC approved',
  accessKycHint: 'Can purchase items over €50',
  requestKyc: 'Request KYC review',
  productPending: 'Product pending',
  viewAllOrders: 'View all orders',
  noPendingProducts: 'No pending products.',
  wallet: 'Wallet',
  topUp: 'Top up',
  lastPurchase: 'Last purchase',
  viewOrders: 'View orders',
  noPurchasesYet: 'No purchases yet.',
  yourFavorites: 'Your favorites',
  viewMore: 'View more',
  noFavoritesPrefix: 'No favorites yet.',
  browseTheCatalog: 'Browse the catalog',
  noFavoritesSuffix: 'and tap the heart on games you like.',

  // Wallet top-up modal
  topup: {
    eyebrow: 'Wallet top-up',
    title1: 'Add',
    titleAccent: 'Funds',
    title2: 'to your wallet',
    subtitle: 'Funds are added instantly to your PlayStock balance for immediate use on the market.',
    accountStatus: 'Account status',
    billingAdded: 'Billing address — added',
    billingMissing: 'Billing address — not added',
    addBilling: 'Add billing address',
    kycVerified: 'KYC — verified',
    kycMissing: 'KYC — not verified',
    requestKyc: 'Request KYC review',
    statusNote: 'Required for purchases above €50.',
    currentBalance: 'Current balance',
    amountToAdd: 'Amount to add',
    newBalance: 'New balance after top-up:',
    cancel: 'Cancel',
    confirmPay: 'Confirm & pay',
    redirectNote: 'You will be redirected to our payment provider.',
    rangeHint: 'Enter an amount between {min} and {max}.',
    failed: 'Could not start top-up. Please try again.',
    returnPending: 'Confirming your top-up…',
    returnPendingText: 'This usually takes a few seconds.',
    returnSuccessPrefix: 'Top-up',
    returnSuccessAccent: 'complete',
    returnSuccessText: 'Your funds have been added to your wallet.',
    returnFailedPrefix: 'Top-up',
    returnFailedAccent: 'failed',
    returnFailedText: 'Your top-up could not be completed. No funds were charged.',
    returnBalance: 'New balance',
    returnToDashboard: 'Go to dashboard',
    returnRetry: 'Try again',
  },

  // Settings — tabs
  tabSettings: 'Settings',
  tabBilling: 'Billing',

  // Settings — personal info
  personalInformation: 'Personal information',
  profileDetails: 'Profile details',
  security: 'Security',
  kycTradingLimits: 'Level 1 trading limits',
  fullName: 'Full name',
  emailAddress: 'Email address',
  verified: 'Verified',
  phoneNumber: 'Phone number',
  country: 'Country',
  birthDate: 'Birth date',
  billingAddress: 'Billing address',
  streetAddress: 'Street address',
  city: 'City',
  postalCode: 'Postal code',
  saveChanges: 'Save changes',
  saving: 'Saving…',
  changesSaved: 'Changes saved.',
  couldNotSaveChanges: 'Could not save changes.',

  // Settings — change password
  changePassword: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  passwordHint: 'Must be at least 8 characters with a letter and a number.',
  confirmNewPassword: 'Confirm new password',
  updatePassword: 'Update password',
  updating: 'Updating…',
  passwordUpdated: 'Password updated.',
  passwordsDoNotMatch: 'New passwords do not match.',
  passwordTooWeak: 'Password must be at least 8 characters with a letter and a number.',
  couldNotUpdatePassword: 'Could not update password.',

  // Settings — KYC
  kycVerification: 'KYC verification',
  verifiedAccount: 'Verified account',
  unverifiedAccount: 'Unverified account',
  kycDescription: 'Verification is required for high-tier purchases and marketplace trading.',

  // Settings — danger zone
  dangerZone: 'Danger zone',
  deletionScheduled: 'Your account is scheduled for deletion on {date}. You can still cancel until then.',
  cancelDeletion: 'Cancel deletion',
  cancelling: 'Cancelling…',
  deleteConfirmPrompt: 'Are you sure? Your account will be permanently deleted after a 7-day grace period.',
  confirm: 'Confirm',
  working: 'Working…',
  keepAccount: 'Keep account',
  deleteAccountDescription: 'Permanently delete your account and remove all data. This action cannot be reversed after 7 days.',
  deleteAccount: 'Delete account',

  // Favorites page
  favoritesTitle: 'Your favorites',
  favoritesSubtitle: "Games you've saved to revisit later.",
  noFavoritesTitle: 'No favorites yet',
  favoritesLoadFailed: "Couldn't load your favorites. Please try again.",
  favoritesEmptyHint: 'Tap the heart on any game to save it here.',
  browseCatalog: 'Browse catalog',
  sessionsTitle: 'Active sessions',
  sessionsDesc: 'Devices currently signed in to your account.',
  sessionCurrent: 'This device',
  sessionLastUsed: 'Last used {date}',
  sessionUnknownDevice: 'Unknown device',
  sessionLogOut: 'Log out',
  sessionsEndOthers: 'End all other sessions',
  sessionsNoOthers: 'No other active sessions.',
  sessionsLoadFailed: "Couldn't load your sessions.",
  contentPrefsTitle: 'Content preferences',
  contentPrefs18: 'I am 18 years old or older',
  contentPrefs18Hint: 'Add your birth date above (you must be 18+) to enable this.',
  contentPrefsExplicit: 'Show explicit, adult content games in the catalog',
  contentPrefsError: "Couldn't update your content preferences.",
};
